import { useLocation } from "react-router";
import { useEffect, useRef, useState } from "react";
import {
  useAccountFetchOrders,
  useAccountState,
} from "@made-people/grease-account";
import { useHref } from "@made-people/grease-link";
import { useTranslate } from "@made-people/grease-translations";
import { Heading } from "@made-people/blueprint-heading";
import { ButtonAsButton } from "@made-people/blueprint-button";
import { OrderCard } from "./OrderCard";
import { OrderDetails } from "./OrderDetails";

export const MissMaryAccountOrders = () => {
  const location = useLocation();
  const [currentOrderNumber, setCurrentOrderNumber] = useState<string | null>(
    null,
  );
  const ordersFetched = useRef(false);
  const orderFetcher = useAccountFetchOrders();
  const account = useAccountState();
  const href = useHref();
  const translate = useTranslate();

  useEffect(() => {
    if (!ordersFetched.current) {
      ordersFetched.current = true;
      orderFetcher.execute();
    }
  }, [orderFetcher]);

  useEffect(() => {
    const orderNumber = new URLSearchParams(location.search).get("orderNumber");
    const orderExists = account.orders?.find(
      (o) => o.orderNumber === orderNumber,
    );

    if (orderExists) {
      setCurrentOrderNumber(orderNumber);
    } else {
      setCurrentOrderNumber(null);
    }
  }, [location, account.orders]);

  if (!account.orders) {
    return (
      <div className="w-full">
        <div className="pt-14 px-4 pb-4 md:pb-6">
          <div className="h-8 w-48 animate-pulse bg-neutral-100 rounded" />
        </div>
        <div className="flex flex-col">
          {[0, 1, 2].map((i) => (
            <div key={i} className="border-b border-border-light py-8 px-4">
              <div className="flex flex-col gap-2">
                <div className="h-4 w-32 animate-pulse bg-neutral-100 rounded" />
                <div className="h-4 w-24 animate-pulse bg-neutral-100 rounded" />
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  const currentOrder =
    currentOrderNumber !== null
      ? account.orders.find((o) => o.orderNumber === currentOrderNumber)
      : undefined;

  return (
    <div className="w-full">
      {currentOrderNumber === null && (
        <Heading
          heading={`${translate("Account_Heading_MyOrders", {
            amountOfOrders: account.orders.length,
          })}`}
          headingTag="h1"
          variants={{ headingSize: { initial: "sm", lg: "md" } }}
          className="pb-4 md:pb-6 hidden lg:block"
        />
      )}
      {/* HELLO TANVEER */}
      {currentOrderNumber === null && (
        <>
          <div className="flex flex-col">
            {account.orders.length === 0 ? (
              <div className="border-y border-border-light">
                <div className="flex flex-col gap-8 py-8 px-4 lg:px-6 max-w-[600px]">
                  <div className="flex flex-col gap-2">
                    <span className="text-body-lg">
                      {translate("Account_Orders_Empty_Heading")}
                    </span>
                    <span className="text-body-sm">
                      {translate("Account_Orders_Empty_Description")}
                    </span>
                  </div>
                  <ButtonAsButton
                    label={translate("Account_Orders_Empty_CTA")}
                    variants={{ width: "full" }}
                    onClick={() => {
                      window.location.href = href("");
                    }}
                  />
                </div>
              </div>
            ) : (
              account.orders.map((order) => (
                <OrderCard
                  key={order.orderNumber}
                  order={order}
                  viewOrderHref={href(
                    `comfort-club?route=orders&orderNumber=${order.orderNumber}`,
                  )}
                />
              ))
            )}
          </div>
        </>
      )}
      {currentOrderNumber !== null && !currentOrder && (
        <div className="px-4 py-8 text-body-sm">
          {translate("Account_Order_Not_Found") || "Order not found"}
        </div>
      )}
      {currentOrderNumber !== null && currentOrder && (
        <OrderDetails
          order={currentOrder}
          backHref={href("comfort-club?route=orders")}
        />
      )}
    </div>
  );
};
